import React from "react";
import { ArrowLeft, ArrowRight, Search, UserRound } from "lucide-react";

const SignupTypePage = ({ onChooseAthlete, onChooseScout, onGoToLogin }) => (
  <main className="min-h-screen bg-white px-4 py-10 sm:py-14">
    <div className="mx-auto flex min-h-[calc(100vh-5rem)] w-full max-w-lg flex-col justify-center sm:min-h-[calc(100vh-7rem)]">
      <button
        type="button"
        onClick={onGoToLogin}
        className="mb-10 flex w-fit items-center gap-2 rounded text-sm text-gray-600 transition-colors hover:text-blue-950 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-900 focus-visible:ring-offset-4"
      >
        <ArrowLeft size={17} aria-hidden="true" />
        Volver a iniciar sesión
      </button>

      <div className="mb-8">
        <h1 className="text-balance text-3xl font-bold uppercase leading-tight tracking-wide text-gray-900 sm:text-4xl">
          ¿Cómo quieres usar <span className="text-alert-300">Athletain</span>?
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-gray-600">
          Elige el tipo de cuenta para mostrarte el registro adecuado.
        </p>
      </div>

      <div className="divide-y divide-gray-200 border-y border-gray-200">
        <button
          type="button"
          onClick={onChooseAthlete}
          className="group flex w-full items-center gap-4 px-1 py-6 text-left transition-colors hover:bg-gray-50 focus:outline-none focus-visible:bg-blue-50"
        >
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-blue-950 text-white">
            <UserRound size={22} aria-hidden="true" />
          </span>
          <span className="min-w-0 flex-1">
            <span className="block font-semibold text-gray-900">Soy atleta</span>
            <span className="mt-1 block text-sm leading-relaxed text-gray-600">
              Quiero crear y compartir mi perfil deportivo.
            </span>
          </span>
          <ArrowRight
            size={20}
            aria-hidden="true"
            className="shrink-0 text-gray-400 transition-transform group-hover:translate-x-1 group-hover:text-blue-950"
          />
        </button>

        <button
          type="button"
          onClick={onChooseScout}
          className="group flex w-full items-center gap-4 px-1 py-6 text-left transition-colors hover:bg-gray-50 focus:outline-none focus-visible:bg-blue-50"
        >
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-athletain-green text-blue-950">
            <Search size={22} aria-hidden="true" />
          </span>
          <span className="min-w-0 flex-1">
            <span className="block font-semibold text-gray-900">Soy reclutador</span>
            <span className="mt-1 block text-sm leading-relaxed text-gray-600">
              Quiero descubrir, evaluar y contactar talento.
            </span>
          </span>
          <ArrowRight
            size={20}
            aria-hidden="true"
            className="shrink-0 text-gray-400 transition-transform group-hover:translate-x-1 group-hover:text-blue-950"
          />
        </button>
      </div>
    </div>
  </main>
);

export default SignupTypePage;
